const { default: styled } = require("styled-components");



export const SPDFViewerModal = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0, 0.5);
    padding: 12px;
    z-index: 100;
    display: flex;
    justify-content: center;
    align-items: center;
    .modal-box {
        width: 95%;
        width: 95%;
        background-color: #f1f1f1;
    }
`